import React from "react"
import { Redirect } from "react-router-dom"

// JSB Forms
import login from "../pages/JSBForms/login"
import Status from "../pages/JSBForms/Status"
import CreateNewAccount from "../pages/JSBForms/CreateNewAccount"

import Registration from "../pages/JSBForms/Registration"
import Success from "../pages/JSBForms/success"
import FormLoader from "../pages/JSBForms/FormLoader"
import FirstHolder from "../pages/JSBForms/FirstHolder"
import OtherHolder from "../pages/JSBForms/OtherHolder"
import ShowPhoto from "../pages/JSBForms/ShowPhoto"
import BranchLogin from "../pages/JSBForms/BranchLogin"
import CustomerList from "../pages/JSBForms/CustomerList"


const authProtectedRoutes = [
    { path: "/Registration", component: Registration },
    { path: "/Status", component: Status },
    { path: "/CreateNewAccount", component: CreateNewAccount },
    { path: "/FirstHolder", component: FirstHolder },
    { path: "/OtherHolder", component: OtherHolder },
    

    { path: "/", exact: true, component: () => <Redirect to="/Status" /> },
]

const publicRoutes = [
    { path: "/login", component: login },
    { path: "/BranchLogin", component: BranchLogin },
    { path: "/success", component: Success },
    { path: "/FormLoader", component: FormLoader },
    { path: "/CustomerList", component: CustomerList },
    { path: "/ShowPhoto", component: ShowPhoto }
]

export { authProtectedRoutes, publicRoutes }
